import '../../styles/components/layout/Header.css';
import Navbar from '../Navbar';


const Header = (props) => {

    return (
        <Navbar />
    );
}

export default Header;